import { TimeSlotConfig } from "../Contingent/TimeSlotProductConfig";

export class Product {
    constructor(id: number, name: string, price: number, originalPrice: number, foreignPrice: number, quantity: number, subProductIdentifier: number, timeSlotGroupKeys: number[], listElement: HTMLElement, timeSlotConfigs: TimeSlotConfig[],  min?: number, max?: number) {
        this.Id = id;
        this.Name = name;
        this.Price = price;
        this.OriginalPrice = originalPrice;
        this.ForeignPrice = foreignPrice;
        this.Quantity = quantity;
        this.SubProductIdentifier = subProductIdentifier;
        this.ListElement = listElement;
        this.TimeSlotGroupKeys = timeSlotGroupKeys;
        this.Min = min;
        this.Max = max;
        this.TimeSlotConfigs = timeSlotConfigs;
    }

    Id: number;
    Name: string;
    Price: number;
    OriginalPrice: number;
    ForeignPrice: number;
    Quantity: number;

    /** Part of Price of the mandatory additional articles (tickets), not discounted by a cross-sale. */
    MandatoryArticlesPrice?: number;

    //PersonType, PackagePosNr
    SubProductIdentifier: number;

    Min?: number;
    Max?: number;
    Sort?: number;

    TimeSlotGroupKeys: number[];
    ListElement: HTMLElement;

    TimeSlotConfigs: TimeSlotConfig[];
}